t = require('app/scripts/views/internal/teacup-with-helpers')('header_search')

module.exports = ->
  t.a '.header-btn.open-search-btn.js-open-search-page', { href: '/search', title: t.l('search-for-boards-cards-members-and-organizations') }, ->
    t.span '.header-btn-icon.icon-md.icon-search.light'

  t.div '.header-search', ->

    t.input '.header-search-input.js-search-input.js-disable-on-dialog', { type: 'text', autocomplete: 'off', autocorrect: 'off', spellcheck: 'false', value: t.mustacheVar('query') }

    t.span '.header-search-icon.icon-md.icon-search.light.js-search-icon'

    t.span '.header-search-icon.header-search-icon-close.icon-md.icon-close.light.hide.js-close-icon.js-search-close'

    t.a '.header-search-icon.header-search-icon-open.icon-md.icon-external-link.light.hide.js-open-button.js-open-search-page', { href: '#' }

